import {
  BuildingLibraryIcon,
  NewspaperIcon,
  ClipboardDocumentListIcon,
  DocumentCheckIcon,
} from "@heroicons/react/24/solid";
import PolicyType from "./PolicyType";
import Standard from "./Standard";
import LicenseType from "./LicenseType";
import BusinessType from "./BusinessType";
import LineOfBusiness from "./LineOfBusiness";
import Risk from "./Risk";
import { AgencyMapping } from "./AgencyMapping";
import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
import PaymentRemittanceType from "./PaymentRemittanceType";
import SalesLead from "./SalesLead";
import MasterLegalEntity from "./MasterLegalEntity";

export const AgreementTabs = [
  {
    to: ROUTE_PATHS.Utilities_configureagreement_PolicyType_Index,
    icon: <BuildingLibraryIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Policy Type",
    component: PolicyType,
    permission:
      PERMISSIONS.permission_utilities_configureagreement_policytype_view,
  },
  {
    path: ROUTE_PATHS.Utilities_configureagreement_SalesLead_Index,
    to: ROUTE_PATHS.Utilities_configureagreement_SalesLead_Index,
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Sales Lead",
    component: SalesLead,
    permission:
      PERMISSIONS.permission_utilities_configureagreement_saleslead_view,
  },
  {
    path: ROUTE_PATHS.Utilities_configureagreement_Standard_Index,
    to: ROUTE_PATHS.Utilities_configureagreement_Standard_Index,
    icon: <ClipboardDocumentListIcon className="h-4 w-4 float-left mr-2" />,
    title: "Standard",
    component: Standard,
    permission:
      PERMISSIONS.permission_utilities_configureagreement_standard_view,
  },
  {
    path: ROUTE_PATHS.Utilities_LicenseType_Index,
    to: ROUTE_PATHS.Utilities_LicenseType_Index,
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2" />,
    title: "License Type",
    component: LicenseType,
    permission: PERMISSIONS.permission_utilities_licensetype_view,
  },
  {
    path: ROUTE_PATHS.Utilities_AgreementConfiguration_BusinessType,
    to: ROUTE_PATHS.Utilities_AgreementConfiguration_BusinessType,
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2" />,
    title: "Business Type",
    component: BusinessType,
    permission:
      PERMISSIONS.permission_utilities_configureagreement_businesstype_view,
  },
  {
    path: ROUTE_PATHS.Utilities_AgreementConfiguration_LineofBusiness,
    to: ROUTE_PATHS.Utilities_AgreementConfiguration_LineofBusiness,
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2" />,
    title: "Line of Business",
    component: LineOfBusiness,
    permission:
      PERMISSIONS.permission_utilities_configureagreement_lineofbusiness_view,
  },
  {
    path: ROUTE_PATHS.Utilities_AgreementConfiguration_Risk,
    to: ROUTE_PATHS.Utilities_AgreementConfiguration_Risk,
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2" />,
    title: "Risk",
    component: Risk,
    permission: PERMISSIONS.permission_utilities_configureagreement_risk_view,
  },
  {
    path: ROUTE_PATHS.Utilities_AgreementConfiguration_AgencyMapping,
    to: ROUTE_PATHS.Utilities_AgreementConfiguration_AgencyMapping,
    icon: <DocumentCheckIcon className="h-4 w-4 float-left mr-2" />,
    title: "Agency Mapping",
    component: AgencyMapping,
    permission:
      PERMISSIONS.permission_utilities_configureagreement_agencymapping_view,
  },
  {
    path: ROUTE_PATHS.Utilities_AgreementConfiguration_PaymentRemittanceType,
    to: ROUTE_PATHS.Utilities_AgreementConfiguration_PaymentRemittanceType,
    icon: <DocumentCheckIcon className="h-4 w-4 float-left mr-2" />,
    title: "Payment Remittance Type",
    component: PaymentRemittanceType,
    permission:
      PERMISSIONS.permission_utilities_configureagreement_paymentremittancetype_view,
  },

  {
    path: ROUTE_PATHS.Utilities_AgreementConfiguration_MasterLegalEntity,
    to: ROUTE_PATHS.Utilities_AgreementConfiguration_MasterLegalEntity,
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2" />,
    title: "Master Legal Entity",
    component: MasterLegalEntity,
    permission:
      PERMISSIONS.permission_utilities_configureagreement_masterlegalentity_view,
  },
];
